import React, { forwardRef } from 'react';

interface FormInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label: string;
  error?: string;
  helperText?: string;
  fullWidth?: boolean;
  leftIcon?: React.ReactNode;
  rightIcon?: React.ReactNode;
  onKeyPress?: React.KeyboardEventHandler<HTMLInputElement>;
  noMargin?: boolean;
}

const FormInput = forwardRef<HTMLInputElement, FormInputProps>(
  ({ label, error, helperText, fullWidth = true, leftIcon, rightIcon, className, noMargin = false, ...rest }, ref) => {
    return (
      <div className={`${noMargin ? '' : 'mb-4'} ${fullWidth ? 'w-full' : ''}`}>
        {label && (
          <label className="block text-sm font-medium text-gray-700 mb-1">{label}</label>
        )}
        <div className="relative">
          {leftIcon && (
            <div className="absolute inset-y-0 left-0 pl-1 flex items-center justify-center pointer-events-none h-full">
              <span className="flex items-center">{leftIcon}</span>
            </div>
          )}

          <input
            ref={ref}
            className={`
              w-full px-4 py-2
              border rounded-md
              focus:outline-none focus:ring-2
              ${error
                ? 'border-red-500 focus:ring-red-500 focus:border-red-500'
                : 'border-gray-300 focus:ring-blue-500 focus:border-blue-500'
              }
              ${leftIcon ? 'pl-10' : ''}
              ${rightIcon ? 'pr-10' : ''}
              ${className || ''}
            `}
            {...rest}
          />

          {rightIcon && (
            <div className="absolute inset-y-0 right-3 flex items-center justify-center pointer-events-none h-full">
              <span className="flex items-center">{rightIcon}</span>
            </div>
          )}
        </div>

        {helperText && !error && (
          <p className="mt-1 text-sm text-gray-500">{helperText}</p>
        )}

        {error && (
          <p className="mt-1 text-sm text-red-600">{error}</p>
        )}
      </div>
    );
  }
);

FormInput.displayName = 'FormInput';

export default FormInput;